const rejectApproval = {
  orderNo: '订单号',
  deliveryNo: 'Delivery号',
  rejectNo: '拒收单号',
  docStatus: '单据状态',
  orderDate: '接单日期',
  customerSignDate: '客户签收时间',
  customerCode: '客户编号',
  customerName: '客户名称',
  rejectItemMaterialNo: '拒收品项物料号',
  rejectItemOldCode: '拒收品项旧代码',
  rejectQty: '拒收数量',
  rejectLocation: '拒收库位',
  productStatus: '产品状态',
  rejectReasonType: '拒收原因类型',
  rejectReason: '拒收原因',
  productReturned: '产品是否退回',
  noticeDate: '通知时间',
  entered3PL: '3PL是否已录入系统',
  remark: '备注',
  todayReject: '是否今日拒收',
  carrierName: '承运商',
  category: '品类',
  dc: 'DC',
  cscEntryDate: 'CSC录入日期',
  //单据状态
  statusRejectCreate: '拒收创建',
  statusPendingApproval: '待审批',
  statusPendingReceipt: '待收货',
  statusRejectDone: '拒收完成',
  //拒收原因
  reasonTransportLost: '运输丢失',
  reasonDamaged: '破损',
  reasonCustomerSpecial: '客户现场特殊要求',
  //客户
  customerPdl: '许昌市胖东来超市有限公司',
  customerJsk: '北京玖施酷科技有限公司-猫超',
  customerQcs: '北京屈臣氏个人用品连锁商店有限公司',
  msg: {}
};
export default rejectApproval;



// WEBPACK FOOTER //
// ./src/page/reject/rejectApproval/lang/rejectApproval.zh.js